import Service from '@/helpers/service'

export default {
    saveAsDraft(payload) {
        return Service().post('stock-calculation/save-draft', payload);
    },
    getSubmissions(params) {
        return Service().get('stock-calculation',  {params});
    },
    getLatestSubmissionCount(params) {
        return Service().get('stock-calculation/latest-submission-count',  {params});
    },
    getSubmissionDetail(id) {
        return Service().get(`stock-calculation/${id}`);
    },
    escalationSave(payload, id, slug) {
        return Service().put(`stock-calculation/escalation/${slug}/${id}`, payload);
    },
    getApprovers() {
        return Service().get(`stock-calculation/get-approved`);
    },
    submit(id, slug, payload) {
        return Service().put(`stock-calculation/${slug}/${id}`, payload);
    },
    revisi(id, payload) {
        return Service().put(`stock-calculation/revisi/${id}`, payload);
    },
    reject(id, payload) {
        return Service().put(`stock-calculation/reject/${id}`, payload);
    },
    approve(id) {
        return Service().put(`stock-calculation/approve/${id}`);
    },
    delete_item(parent_id, id) {
        return Service().delete(`stock-calculation/delete-item/${parent_id}/${id}`);
    },
}